import { selectProductStock } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from './queries/useCartQuery';

export const useProductStock = () => {
    const { cart } = useCartQuery();
    const stock = selectProductStock(cart);

    if (stock?.nextDeliveryDate) {
        const localizedStockShipmentDate = new Date(stock.nextDeliveryDate).toLocaleDateString('lt-LT', {
            month: 'long',
            day: 'numeric',
        });

        return {
            stock,
            localizedStockShipmentDate,
        };
    }

    return {
        stock,
        localizedStockShipmentDate: undefined,
    };
};
